import { render } from "./commentaire.vue?vue&type=template&id=a122658e&scoped=true"
import script from "./commentaire.vue?vue&type=script&lang=js"
export * from "./commentaire.vue?vue&type=script&lang=js"

import "./commentaire.vue?vue&type=style&index=0&id=a122658e&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a122658e"]])

export default __exports__